import * as React from "react";

function SvgElevio(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 511 511" {...{ ...props, ref }}>
      <path
        d="M255.411 0C114.76 0 0 114.759 0 255.411c0 140.653 114.759 255.412 255.411 255.412 141.242 0 255.412-114.759 255.412-255.412C510.823 114.76 396.653 0 255.411 0zm58.263 425.49c-11.182 0-20.01-9.416-20.01-20.598 0-11.182 8.828-20.598 20.01-20.598 11.181 0 20.009 9.416 20.009 20.598 0 11.182-8.828 20.598-20.01 20.598zm65.912-131.826c0 10.593-8.239 18.833-18.832 18.833H334.86l-21.186 38.252-21.775-38.252-143.596-7.651c-10.593 0-18.832-8.24-18.832-18.832v-141.83c0-10.593 8.24-18.832 18.832-18.832l212.451-7.65c10.593 0 18.832 8.238 18.832 18.831v157.131z"
        fill="#03A9F4"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgElevio);
